export default "__VITE_ASSET__28bbee81__"